import api from "./api";

const auth = {
    postLogin(body) {
        return api.post("/auth/login", body);
    },
};

export default auth;
